module.exports = __webpack_public_path__ + "img/truck-network.7e824645.svg";